import apiSvc from "../../services/api-service";
import { getDataSources } from "./data-sources-action";

export async function loadDataSources(dispatch: any) {
  apiSvc.get('SelectDataSourcesRequest').then((response) => dispatch(getDataSources(response?.data.Data)));
}
